import React from 'react';
import { useEvents } from '~/core/events/eventsContext';
import { ResultType } from '~/core/results/types/results.type';

export interface UseGoToResultHandlerParams {
    searchQuery: string;
    /** Used for analytics */
    resultsCount: number;
    isInstantSearch: boolean;
}

export interface GoToResultHandlerParams {
    url: string;
    order: number;
    resultType: ResultType;
    openInNewTab?: boolean;
}
export type GoToResultHandler = (params: GoToResultHandlerParams) => void;

const useGoToResult = ({
    searchQuery,
    resultsCount,
    isInstantSearch,
}: UseGoToResultHandlerParams): { handleGoToResult: GoToResultHandler } => {
    const {
        eventEmitter: { emitConfirmableEvent },
        eventFactory: { createGoToResultEvent },
    } = useEvents();

    const handleGoToResult = React.useCallback(
        ({ url, order = 0, resultType, openInNewTab = false }: GoToResultHandlerParams) => {
            (async () => {
                const [gaConfirmation, aaConfirmation] = await emitConfirmableEvent(
                    createGoToResultEvent({
                        searchQuery,
                        resultsCount,
                        resultType,
                        url,
                        order,
                        serpType: isInstantSearch ? 'instant' : 'full',
                    }),
                    150
                );

                if (openInNewTab) {
                    window.open(url);
                    return;
                }

                window.location.href = url;

                // WHY IS THIS HERE?
                // if (event.type === 'keydown') {
                //     window.location.href = url;
                // } else {
                //     if (event.button === 1 || (event.button === 0 && event.ctrlKey)) {

                //     }

                // }
            })();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [searchQuery, resultsCount]
    );

    return { handleGoToResult };
};

export default useGoToResult;
